import {createError} from "core/exceptions";
import log from "loglevel";
import {call, put, select, takeLatest} from "redux-saga/effects";
import {actions, transformDataToFilmReportChart,} from "./actions";

import {transformArrayToValue} from "core/dataConstants";
import StatisticsService from "services/statisticsService";
import {DATE_FORMAT_SHORT, DATE_FORMAT_ZONE_TIME_LONG, formatDate} from "components/common/dateUtils";
import {assertArray} from "core/validation";

export const reviewUserFormSelector = (state) => state.statistics.reviewUserForm;
export const tagFormSelector = (state) => state.statistics.tagsForm;
export const categoryReportFormSelector = (state) => state.statistics.filmReleaseForm;
export function convertParamsReviewUserForm(form) {
    return {
        statuses: transformArrayToValue(form.statuses),
        companyIds: transformArrayToValue(form.companies),
        dateInterval: form.dateInterval ? form.dateInterval.value.value : "CUSTOM_DATE",
        dateFrom:
            form.dateInterval && form.dateInterval.dateFrom
                ? formatDate(form.dateInterval.dateFrom, DATE_FORMAT_SHORT)
                : null,
        dateTo:
            form.dateInterval && form.dateInterval.dateTo
                ? formatDate(form.dateInterval.dateTo, DATE_FORMAT_SHORT)
                : null,
        users: transformArrayToValue(form.users),
        countAllVersions: form.countAllVersions
    };
}

export function convertParamsTagUserForm(form) {
    return {
        tagIds: transformArrayToValue(form.tags),
        advTypeIds: transformArrayToValue(form.advTypes),
        companyIds: transformArrayToValue(form.companies),
        dateInterval: form.dateInterval ? form.dateInterval.value.value : "CUSTOM_DATE",
        dateFrom: form.dateInterval && form.dateInterval.dateFrom ? formatDate(form.dateInterval.dateFrom, DATE_FORMAT_ZONE_TIME_LONG): null,
        dateTo: form.dateInterval && form.dateInterval.dateTo ? formatDate(form.dateInterval.dateTo, DATE_FORMAT_ZONE_TIME_LONG): null,
    };
}
export function convertParamsFilmCategoryReportForm(form) {
    return {
        ratingCategory: form.ratingCategory ? [form.ratingCategory] : [],
        ratingSubCategory: assertArray(form.ratingSubCategory) ? form.ratingSubCategory.map(e => e.value) : [],
        companyIds: transformArrayToValue(form.companies),
        dateInterval: form.dateInterval ? form.dateInterval.value.value : "CUSTOM_DATE",
        dateFrom:
            form.dateInterval && form.dateInterval.dateFrom
                ? formatDate(form.dateInterval.dateFrom, DATE_FORMAT_SHORT)
                : null,
        dateTo:
            form.dateInterval && form.dateInterval.dateTo
                ? formatDate(form.dateInterval.dateTo, DATE_FORMAT_SHORT)
                : null
    };
}
export function* reviewUserFetch() {
    try {
        const form = yield select(reviewUserFormSelector);

        try {
            const params = convertParamsReviewUserForm(form);
            const data = yield call(StatisticsService.runReviewUsers, params);
            yield put(actions.RUN_REVIEW_USER_QUERY.success({ data }));
        } catch (e) {
            log.error(e);
            yield put(actions.RUN_REVIEW_USER_QUERY.failed(null, createError(e)));
        }
    } catch (error) {
        log.error(error);
    }
}

export function* tagsQueryFetch() {
    try {
        const form = yield select(tagFormSelector);
        try {
            const params = convertParamsTagUserForm(form);
            const { data } = yield call(
                StatisticsService.runTagsQuery,
                params,
                form.tags ? form.tags.map((t) => t.value) : null
            );
            log.debug(data);
            yield put(actions.RUN_TAGS_QUERY.success({ data }));
        } catch (e) {
            log.error(e);
            yield put(actions.RUN_TAGS_QUERY.failed(null, createError(e)));
        }
    } catch (error) {
        log.error(error);
    }
}

export function* categoryQueryReportSearch() {
    const form = yield select(categoryReportFormSelector);
    try {
        const params = convertParamsFilmCategoryReportForm(form);
        const { data } = yield call(
            StatisticsService.runCategoryReportQuery,
            params,
        );
        const finalData = transformDataToFilmReportChart(data);
        yield put(actions.RUN_CATEGORY_REPORT_QUERY_REPORT.success({ data: finalData }));
    } catch (e) {
        log.error(e);
        yield put(actions.RUN_CATEGORY_REPORT_QUERY_REPORT.failed(null, createError(e)));
    }
}

export default [
    takeLatest(actions.RUN_REVIEW_USER_QUERY.sendType, reviewUserFetch),
    takeLatest(actions.RUN_TAGS_QUERY.sendType, tagsQueryFetch),
    takeLatest(actions.RUN_CATEGORY_REPORT_QUERY_REPORT.sendType, categoryQueryReportSearch),
];
